import BaseRepository from '@/api/repositories/BaseRepository';
import store from '@/store/index';

export default class SpecialOfferTemplateRepository extends BaseRepository {
	getTemplates(page, paginate) {
		return this.get('specialOfferTemplates', { page: page, paginate: paginate });
	}

	storeTemplate(data) {
		return this.post('specialOfferTemplates', {}, data);
	}

	deleteTemplate(id) {
		return this.delete(`specialOfferTemplates/${id}`);
	}

	getTemplateById(id) {
		return this.get(`specialOfferTemplates/${id}`, {});
	}

	updateTemplate(id, data) {
		return this.put(`specialOfferTemplates/${id}`, {}, data);
	}
}
